<template>
  <finance-drawer
    title="退款单详情"
    width="70%"
    v-bind="$attrs"
    v-on="$listeners"
    :title-no="refundOrderNo"
    :modal-close="false"
    @refresh="handleOpen"
  >
    <div slot="drawer-operation">
      <btns-operate :current="detailInfo" @success="init" :show="['WAIT'].includes(detailInfo.refundStatus)" />
    </div>
    <div class="main-cont" v-loading="loading">
      <div class="main-cont-item">
        <h2 class="title-text">
          基础信息
          <icon-status
            :color="statusColorFilters(detailInfo.refundStatus)"
            :status="detailInfo.refundStatusDesc"
          />
        </h2>
        <el-row :gutter="20" style="margin-top: -8px;">
          <jr-col :data-show="firstCol" :data="detailInfo" />
          <jr-col :data-show="secondCol" :data="detailInfo" />
          <jr-col :data-show="thirdCol" :data="detailInfo" />
        </el-row>
        <el-row>
          <data-show label="退款原因:">
            <div>{{detailInfo.refundReason || '-'}}</div>
          </data-show>
        </el-row>
      </div>
      <trading-card :data="detailInfo" title="退款信息" />
      <div class="main-cont-item">
        <h2 class="title-text">退款凭证</h2>
        <div>
          <div v-if="!detailInfo.certificate" class="no-certificate">无凭证</div>
          <jr-preview-image v-else :image-list="$stringToArray(detailInfo.certificate)|| []" :is-own="true" />
        </div>
      </div>
      <div class="main-cont-item" v-if="orderModifyList.length">
        <h2 class="title-text">订单修改申请信息</h2>
        <jr-table
          :size="formSize"
          :tableData="orderModifyList"
          :tableColumn="orderTableColumn"
        />
      </div>
      <div class="main-cont-item">
        <h2 class="title-text">退款申请信息</h2>
        <jr-table
          :size="formSize"
          :tableData="detailInfo.refundApplyInfos"
          :tableColumn="tableColumn"
        />
      </div>
      <div class="main-cont-item">
        <h2 class="title-text">退款渠道信息</h2>
        <jr-table
          :size="formSize"
          :tableData="detailInfo.refundChannelInfos"
          :tableColumn="refundTableColumn"
        />
      </div>
    </div>
  </finance-drawer>
</template>
<script>
import { getRefundChannelDetail } from '@/api/refund';
import { getOrderDetail } from '@/api/approval/order';
import btnsOperate from './btns-operate';
import { setStatusColor } from '@/filters/index';
import tradingCard from './trading-card';

export default {
  props: {
    refundOrderNo: {
      type: String,
      default: '',
    },
    applyNo: {
      type: String,
      default: '',
    },
  },
  components: { btnsOperate, tradingCard },
  data() {
    return {
      detailInfo: {},
      loading: false,
      // 基础信息
      firstCol: [
        { label: '客户编号:', prop: 'businessNo' },
        { label: '客户名称:', prop: 'businessName' },
        { label: '退款类型:', prop: 'refundTypeDesc' },
        { label: '原交易单号:', prop: 'origTransNum' },
        { label: '退款方式:', prop: 'refundWayDesc' },
        { label: '退款渠道:', prop: 'refundChannelDesc' },
      ],
      secondCol: [
        { label: '申请人:', prop: 'createUser' },
        { label: '申请时间:', prop: 'createTime', filters: 'formatTime' },
        { label: '审核人:', prop: 'approver' },
        { label: '审核时间:', prop: 'approvalTime', filters: 'formatTime' },
        { label: '操作人:', prop: 'operator' },
        { label: '操作时间:', prop: 'operateTime', filters: 'formatTime' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '业务类型:', prop: 'busiTypeDesc' },
        { label: '服务商编号:', prop: 'payeeBusinessNo' },
        { label: '服务商名称:', prop: 'payeeBusinessName' },
      ],
      tableColumn: [
        { label: '退款申请编号', prop: 'refundApplyNo' },
        { label: '原交易单号', prop: 'origTransNum' },
        { label: '退款申请金额(元)', prop: 'refundAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '申请时间', prop: 'createTime', filterName: 'formatTime' },
        { label: '本次退款金额(元)', prop: 'refundCurrentAmount', filterName: 'toFenThousandsAndFloat' },
      ],
      refundTableColumn: [
        { label: '渠道流水号', prop: 'thirdSerialNumber' },
        { label: '退款渠道', prop: 'refundChannelDesc' },
        { label: '退款金额(元)', prop: 'refundAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '创建时间', prop: 'createTime', filterName: 'formatTime' },
        { label: '完成时间', prop: 'thirdFinishTime', filterName: 'formatTime' },
        {
          label: '状态',
          status: 'refundStatus',
          statusDesc: 'refundStatusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
        { label: '备注', prop: 'remark' },
      ],
      orderTableColumn: [
        { label: '申请编号', prop: 'applyNo' },
        { label: '订单编号', prop: 'orderNumber' },
        { label: '订单原金额(元)', prop: 'origOrderAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '订单新金额(元)', prop: 'newOrderAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '本次退款金额(元)', prop: 'refundAmountByModify', filterName: 'toFenThousandsAndFloat' },
        { label: '申请时间', prop: 'crtime', filterName: 'formatTime' },
      ],
      orderModifyList: [],
    };
  },
  watch: {
    refundOrderNo: {
      deep: true,
      handler() {
        if (this.refundOrderNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.detailInfo = {};
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      this.getApplyDetail();
      this.getOrderDetail();
    },
    statusColorFilters(status) {
      return setStatusColor(status, 'refundStatus');
    },
    async getOrderDetail() {
      try {
        const res = await getOrderDetail({ applyNo: this.applyNo });
        this.orderModifyList = res.data ? [res.data] : [];
      } catch (error) {
        console.log(error);
        this.orderModifyList = [];
      }
    },
    // 获取详情接口
    async getApplyDetail() {
      try {
        this.loading = true;
        const res = await getRefundChannelDetail({ refundOrderNo: this.refundOrderNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
        this.detailInfo = {};
      } finally {
        this.loading = false;
      }
    },
    refreshList() {},
  },
};
</script>

